angular.module('dnecom').directive('appendQueryParams', function () {
    return {
        scope: {
            params: '=appendQueryParams'
        },
        link: function (scope, element, attrs) {
            scope.$watch(attrs.href, function(){
                var link = angular.element(element)[0];
                var queryStringParams = [];

                angular.forEach(scope.params, function(value, key) {
                    queryStringParams.push(key + '=' + encodeURIComponent(value));
                });

                link.search = link.search + (link.search ? '&' : '?') + queryStringParams.join('&');
            });
        }
    };
});
